import React, { useState } from "react";
import styled from "styled-components";
import addToMailchimp from "gatsby-plugin-mailchimp";
import { Box } from "reflexbox";

import * as colors from "../styles/colors";
import * as values from "../styles/values";

import ArrowRight from "../images/icons/arrow-right.inline.svg";
import { Container } from "./Container";
import { Copy } from "./Copy";

const Form = styled.form`
  position: relative;
  display: flex;
`;

const InputButton = styled.button`
  display: flex;
  align-items: center;
  position: absolute;
  right: 0px;
  top: 0px;
  height: 100%;
  padding: 0px 11px;
  min-width: auto;
  min-height: auto;
  border: none;
  background-color: transparent;
`;

const HeadingContainer = styled(Box)`
  width: fit-content;
  font-size: 18px;
  font-weight: ${values.regularFontWeight};
  background-image: ${({ $accentColor }) => $accentColor};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -moz-background-clip: text;
  -moz-text-fill-color: transparent;
`;

const EmailInput = styled(Form)`
  height: 46px;
`;

export function Newsletter({
  color = colors.text,
  accentColor = colors.blueGradient,
  headingStyle
}) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  async function onSubmit(event) {
    event.preventDefault();

    const { result, msg } = await addToMailchimp(email);

    setMessage(msg);
    if (result === "success") {
      setEmail("");
    }
  }

  return (
    <Container maxWidth={230}>
      <HeadingContainer
        mb="14px"
        $accentColor={accentColor}
        style={headingStyle}
      >
        Get updates
      </HeadingContainer>
      {message ? (
        <Box mb="14px" width="fit-content">
          <Copy
            size="13px"
            color={color}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </Box>
      ) : null}
      <EmailInput onSubmit={onSubmit}>
        <Box
          as="input"
          p={["10px 45px 10px 16px"]}
          width="100%"
          fontSize="12px"
          color={color}
          sx={{
            borderRadius: "8px",
            border: "1px solid transparent",
            boxShadow: "none",
            backgroundColor: colors.footerInputBackround,
            "::placeholder": {
              color
            },
            ":focus": {
              boxShadow: "none",
              border: `1px solid ${colors.mailBlue}`,
              color: colors.whiteLightColor
            }
          }}
          type="email"
          name="email"
          label="email"
          aria-label="email"
          placeholder="Email address"
          value={email}
          required={true}
          autoComplete="off"
          onChange={(event) => {
            setEmail(event.target.value);
          }}
        />
        <InputButton type="submit" aria-label="Newsletter sign up">
          {email && email.length > 0 && <ArrowRight fill={color} />}
        </InputButton>
      </EmailInput>
    </Container>
  );
}
